// Local audio assets for Winamp playlist (ensures playback without CORS)
import trackTouchMe from 'assets/music/[SPOTIFY-DOWNLOADER.COM] Touch Me.mp3';
import trackDaydream from 'assets/music/spotifydown.com - Daydream.mp3';
import trackAdore from 'assets/music/[SPOTIFY-DOWNLOADER.COM] Adore.mp3';
import trackAllOfASudden from 'assets/music/[SPOTIFY-DOWNLOADER.COM] All Of A Sudden.mp3';
import trackCongaRockAnden from 'assets/music/[SPOTIFY-DOWNLOADER.COM] Conga Rock - Anden Remix.mp3';
import trackEscapeJohnSummit from 'assets/music/[SPOTIFY-DOWNLOADER.COM] Escape - John Summit Remix.mp3';
import trackFather from 'assets/music/[SPOTIFY-DOWNLOADER.COM] Father.mp3';
import trackFineDayAnthem from 'assets/music/[SPOTIFY-DOWNLOADER.COM] Fine Day Anthem.mp3';
import trackFractions from 'assets/music/[SPOTIFY-DOWNLOADER.COM] Fractions.mp3';
import trackGreyhound from 'assets/music/[SPOTIFY-DOWNLOADER.COM] Greyhound.mp3';
import trackHoneyTrap from 'assets/music/[SPOTIFY-DOWNLOADER.COM] Honey Trap.mp3';
import trackLikeAnEcho from 'assets/music/[SPOTIFY-DOWNLOADER.COM] Like an Echo.mp3';
import trackLiquidFantasy from 'assets/music/[SPOTIFY-DOWNLOADER.COM] Liquid Fantasy.mp3';
import trackLookingForMe from 'assets/music/[SPOTIFY-DOWNLOADER.COM] Looking For Me.mp3';
import trackTruckie from "assets/music/[SPOTIFY-DOWNLOADER.COM] Me Dad's A Truckie - Original Mix.mp3";
import trackTheMirage from 'assets/music/[SPOTIFY-DOWNLOADER.COM] The Mirage.mp3';
import trackSezon from 'assets/music/[SPOTIFY-DOWNLOADER.COM] Sezon.mp3';
import trackShinin from "assets/music/[SPOTIFY-DOWNLOADER.COM] Shinin'.mp3";
import trackThunderclouds from 'assets/music/[SPOTIFY-DOWNLOADER.COM] Thunderclouds - Lost Frequencies Remix.mp3';
import trackTYSD from 'assets/music/[SPOTIFY-DOWNLOADER.COM] T.Y.S.D. (Throw Your Soul Down) - HoneyLuv Remix.mp3';
import trackUnderTheSun from 'assets/music/[SPOTIFY-DOWNLOADER.COM] Under The Sun.mp3';
import trackUntilTomorrow from 'assets/music/[SPOTIFY-DOWNLOADER.COM] Until Tomorrow - Da Africa Deep Remix.mp3';
import trackVapid from 'assets/music/[SPOTIFY-DOWNLOADER.COM] Vapid.mp3';
import trackYouGiveMeAFeeling from 'assets/music/[SPOTIFY-DOWNLOADER.COM] You Give Me A Feeling.mp3';
import trackBrooklynHouseGangsta from 'assets/music/spotifydown.com - Brooklyn House Gangsta.mp3';
import trackYouSay from 'assets/music/spotifydown.com - You Say.mp3';

// Winamp playlist content: update, add, or remove tracks here.
const album = 'UNTDL2';
export const initialTracks = [
  {
    url: trackTouchMe,
    duration: 325,
    metaData: {
      title: 'Touch Me',
      artist: 'Rui Da Silva, Cassandra Fox',
      album,
    },
  },
  {
    url: trackDaydream,
    duration: 463,
    metaData: { title: 'Daydream', artist: 'I Hate Models', album },
  },
  {
    url: trackAdore,
    duration: 209,
    metaData: { title: 'Adore', artist: 'Bob Sinclar', album },
  },
  {
    url: trackAllOfASudden,
    duration: 330,
    metaData: {
      title: 'All of a Sudden',
      artist: 'The Chemical Brothers',
      album,
    },
  },
  {
    url: trackCongaRockAnden,
    duration: 164,
    metaData: {
      title: 'Conga Rock - Anden Remix',
      artist: 'Diplo, Mat.Joe, Toto Bona Lokua, Anden',
      album,
    },
  },
  {
    url: trackEscapeJohnSummit,
    duration: 227,
    metaData: {
      title: 'Escape - John Summit',
      artist: 'deadmau5, Kascade, John Summit',
      album,
    },
  },
  {
    url: trackFather,
    duration: 206,
    metaData: { title: 'Father', artist: 'Will Clarke', album },
  },
  {
    url: trackFineDayAnthem,
    duration: 194,
    metaData: {
      title: 'Fine Day Anthem',
      artist: 'Skrillex, Boys Noize',
      album,
    },
  },
  {
    url: trackFractions,
    duration: 197,
    metaData: { title: 'Fractions', artist: 'Vintage Culture', album },
  },
  {
    url: trackGreyhound,
    duration: 410,
    metaData: { title: 'Greyhound', artist: 'Swedish House Mafia', album },
  },
  {
    url: trackHoneyTrap,
    duration: 585,
    metaData: { title: 'Honey Trap', artist: 'Hozho', album },
  },
  {
    url: trackLikeAnEcho,
    duration: 220,
    metaData: { title: 'Like an Echo', artist: 'LUPA', album },
  },
  {
    url: trackLiquidFantasy,
    duration: 330,
    metaData: {
      title: 'Liquid Fantasy',
      artist: 'Agents Of Time, Vintage Culture',
      album,
    },
  },
  {
    url: trackLookingForMe,
    duration: 211,
    metaData: {
      title: 'Looking For Me',
      artist: 'Paul Woolford, Diplo, Kareen Lomax',
      album,
    },
  },
  {
    url: trackTruckie,
    duration: 278,
    metaData: {
      title: "Me Dad's A Truckie - Original Mix",
      artist: 'Cut Snake',
      album,
    },
  },
  {
    url: trackTheMirage,
    duration: 372,
    metaData: { title: 'The Mirage', artist: 'Agents of Time', album },
  },
  {
    url: trackSezon,
    duration: 439,
    metaData: { title: 'Sezon', artist: 'Angelov', album },
  },
  {
    url: trackShinin,
    duration: 171,
    metaData: { title: "Shinin'", artist: 'Ethan Healy', album },
  },
  {
    url: trackThunderclouds,
    duration: 196,
    metaData: {
      title: 'Thunderclouds - Lost Frequencies Remix',
      artist: 'LSD, Lost Frequencies',
      album,
    },
  },
  {
    url: trackTYSD,
    duration: 195,
    metaData: {
      title: 'T.Y.S.D. - HoneyLuv Remix',
      artist: 'Will Clarke, Sharlene Hector, HoneyLuv',
      album,
    },
  },
  {
    url: trackUnderTheSun,
    duration: 208,
    metaData: { title: 'Under the Sun', artist: 'Franky Wah, AR/CO', album },
  },
  {
    url: trackUntilTomorrow,
    duration: 489,
    metaData: {
      title: 'Until Tomorrow - Da Africa Deep Remix',
      artist: 'Chelsea Como, Jacko, Da Africa Deep',
      album,
    },
  },
  {
    url: trackVapid,
    duration: 223,
    metaData: {
      title: 'Vapid (feat. Louisahhh)',
      artist: 'Golden Features, Louisahhh',
      album,
    },
  },
  {
    url: trackYouGiveMeAFeeling,
    duration: 186,
    metaData: {
      title: 'You Give Me a Feeling',
      artist: 'Vintage Culture, James Hype',
      album,
    },
  },
  {
    url: trackBrooklynHouseGangsta,
    duration: 125,
    metaData: { title: 'Brooklym House Gangsta', artist: 'DANK', album },
  },
  {
    url: trackYouSay,
    duration: 172,
    metaData: { title: 'You Say', artist: 'Maur, Roobinz', album },
  },
];
